<template>
  <div class="container" v-show="manyloginToast">
    <div class="toast">
      <img src="../../assets/error-circle-filled@2x.png" alt="" />

      <p>提示</p>
      <div class="img" @click="manyloginToastHidden"></div>
      <p>系统监测到该账号行为异常，请稍后尝试。</p>
      <div class="btn" @click="manyloginToastHidden">确定</div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  props: ["manyloginToast"],
  data() {
    return {};
  },
  methods: {
    ...mapMutations(["manyloginToastHidden"]),
  },
};
</script>

<style lang="scss" scoped>
.container {
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 99;
  .toast {
    width: 384px;
    height: 200px;
    background: #ffffff;
    border-radius: 8px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    padding-right: 32px;
    box-sizing: border-box;
    img:nth-child(1) {
      width: 20px;
      height: 20px;
      margin-top: 26px;
      margin-left: 32px;
    }
    p:nth-child(2) {
      height: 24px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 24px;
      margin-top: 24px;
      margin-left: 8px;
    }
    .img {
      background: url("../../assets/icon／close@2x.png");
      width: 16px;
      height: 16px;
      margin-top: 24px;
      margin-left: 244px;
      background-size: cover;
      cursor: pointer;
      &:hover {
        background: url("../../assets/icon／close@2x\(1\).png");
        width: 16px;
        height: 16px;
        margin-top: 24px;
        margin-left: 244px;
        background-size: cover;
      }
    }
    p:nth-child(4) {
      height: 44px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 22px;
      margin: 16px 0 0 60px;
    }
    .btn {
      width: 80px;
      height: 32px;
      background: #165dff;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 32px;
      text-align: center;
      margin-top: 28px;
      margin-left: 272px;
      cursor: pointer;
      &:hover {
        background-color: #4080ff;
      }
    }
  }
}
</style>
